module.exports = __webpack_public_path__ + "static/media/highfive.b20fb380.png";